/* -------------------------------------------
   LAYER GROUPS STATIC CONFIG

   FEATURES tab = static sections here + the DERIVED flat list off
   vector_assets (see FeatureCatalogList / GET /api/v1/feature-catalog).

   Only Wells stays static/configured: the RRC well types are shared/global
   (not org-derived) and keep their point+line geometry sub-rows. Everything
   else — pads (well_pad) and the former comingSoon stubs (transport, ownership,
   compliance) — is now real vector_assets data surfaced by the derived list,
   so those stub groups were retired.
------------------------------------------- */
export const LAYER_GROUPS_STATIC = [

  /* Wells — wired via RRC vector tile server */
  {
    id: "operational.wells",
    title: "RRC Information",
    asset: "wells",
    defaultOpen: false,
    layers: [
      {
        id: "wells.surface",
        label: "RRC Surface Wells",
        icon: "CircleDot",
        geometry: "point",
        assetType: "rrc_well_surface",
      },
      {
        id: "wells.lateral",
        label: "RRC Laterals",
        icon: "GitBranch",
        geometry: "line",
        assetType: "rrc_well_lateral",
      },
    ],

    // ── The two regulatory layers 066 made reachable ──────────────────────
    //
    // NESTED SUB-GROUPS, ONE PER ASSET KEY, AND THE NESTING IS LOAD-BEARING.
    // Both are points. If they sat in the `layers` array above they would
    // inherit this group's `asset: "wells"`, and RrcInfoPanel keys a row's
    // on-state and toggle on (asset, layer.geometry) — see RrcInfoPanel.jsx
    // :100,106 — so all three point rows would share
    // assets.wells.geometry.point, toggle together, and be indistinguishable.
    //
    // A per-LAYER `asset` was the obvious alternative and does not work here.
    // The two walkers over this config disagree: useActiveLayers.js:64 reads
    // `l.asset ?? effectiveAsset` and honors it, while RrcInfoPanel's
    // flattenLayers reads only `container.asset` and attaches it to every layer
    // in that container. A sub-group carries `asset` on the container, which is
    // the form BOTH walkers already inherit through — flattenLayers' own
    // comment describes exactly this ("inherited from the nearest ancestor that
    // declares one"). Rows still render flat and in order: surface, lateral,
    // then these two.
    //
    // LABELS. "UIC" expands to nothing outside regulatory affairs, and what a
    // user wants to know is what the wells DO — injection and disposal,
    // saltwater and enhanced recovery. "Permitted Locations" rather than
    // "Permits" because the features are places on a map, not paperwork; a row
    // labelled Permits invites a click expecting documents.
    groups: [
      {
        id: "operational.wells.uic",
        asset: "wells_uic",
        layers: [
          {
            id: "wells.uic",
            label: "RRC Injection & Disposal",
            icon: "ArrowDownToDot",
            geometry: "point",
            assetType: "rrc_well_uic",
          },
        ],
      },
      {
        id: "operational.wells.permit",
        asset: "permits",
        layers: [
          {
            id: "wells.permit",
            label: "RRC Permitted Locations",
            icon: "MapPin",
            geometry: "point",
            assetType: "rrc_permit",
          },
        ],
      },
    ],
  },

];
